export default {
    ANULADA: { texto: 'Anulada', valor: 'ANULADA' },
    DESERTO_FRACASSADO: { texto: 'Deserto/Fracassado', valor: 'DESERTO_FRACASSADO'},
    REVOGADA: { texto: 'Revogada', valor: 'REVOGADA' },
    REVOGACAO_DA_SUSPENSAO_OU_RETOMADA_DA_LICITACAO: {
        texto: 'Revogada da Suspensão ou Retomada da Licitação',
        valor: 'REVOGACAO_DA_SUSPENSAO_OU_RETOMADA_DA_LICITACAO',
    },
    SUSPENSA: { texto: 'Suspensa', valor: 'SUSPENSA' }

}